/* import __COLOCATED_TEMPLATE__ from './learn-about-fin-dropdown-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();